import {URLS, $subscriber} from 'fire-wind-water';
import * as expired from '../../../art/common/expired.art';
import {settings} from '../../common/setting';
import {scmsService} from '../../services/site';

export function preview() {
  const tenantId = URLS.getURL('tid');
  const siteId = URLS.getURL('sid');
  const category = URLS.getURL('cy');
  const timestamp = URLS.getURL('t');
  if (tenantId && siteId && category) {
    settings.tenantId = tenantId;
    settings.siteId = siteId;
    settings.category = category;
    scmsService.getList({tenantId, siteId, category}, (res) => {
      if (res.result == 0) {
        const time = res.content.time;
        const difference = 24 * 60 * 60;
        if (timestamp && (time - timestamp > difference || timestamp > time)) {
          document.body.innerHTML = expired();
          return;
        }
        $subscriber.emit('scms-template', {data: res.content});
        $('body').addClass('preview');
      }
    });
  }
}